import React, { useRef, useState } from 'react';

import LocationAutocompleteContainer from 'dpl/search/containers/LocationAutocompleteContainer';
import LocationResult from 'dpl/search_result_filters/components/UserLocation/LocationResult';
import Icon from 'dpl/common/components/Icon';
import { navigateToShelterResults } from 'dpl/shelter_search_results/utils';

export default function SheltersSearch() {
  const shelterLocationRef = useRef(null);
  const [shelterLocationValue, setShelterLocationValue] = useState('');

  function handleLocationInputChange(e) {
    setShelterLocationValue(e.target.value);
  }

  function handleLocationSelect(location) {
    setShelterLocationValue(location.name);

    navigateToShelterResults(location);
  }

  return (
    <div className="SheltersSearch relative">
      <LocationAutocompleteContainer
        classes={{
          menu: 'ShelterSearchResultsList br3 dropdown-box-shadow mt4',
          selectedMenuItem: 'bg-subtle-gray br2'
        }}
        inputProps={{
          name: 'shelter-location',
          type: 'text',
          ref: shelterLocationRef,
          className: 'w-100 bn br12 pl6 pr13 pv6 font-18 font-serif',
          onChange: handleLocationInputChange,
          placeholder: 'Add your location'
        }}
        menuCloseTimeout={300}
        onSelect={handleLocationSelect}
        query={shelterLocationValue}
        ResultsItemComponent={LocationResult}
        resultsItemProps={{
          classes: {
            wrapper: 'fw-medium ph4 pv3',
            icon: 'pv3 ph3'
          },
          iconSize: '24px'
        }}
        stripCountryCode
      />
      <div className="absolute transform-center right-0 mr6">
        <Icon
          className="primary"
          name="fetch-search"
          height="20px"
          width="20px"
        />
      </div>
    </div>
  );
}
